'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TimeTrackingAppIcon = function TimeTrackingAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    version: "1.1"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("circle", {
    id: "path-1",
    cx: "250",
    cy: "250",
    r: "250"
  }), React__default["default"].createElement("linearGradient", {
    x1: "31.9322755%",
    y1: "18.1464695%",
    x2: "84.7893082%",
    y2: "48.8164699%",
    id: "linearGradient-2"
  }, React__default["default"].createElement("stop", {
    stopColor: "#1E88E5",
    offset: "0%"
  }), React__default["default"].createElement("stop", {
    stopColor: "#1976D2",
    stopOpacity: "0",
    offset: "100%"
  }))), React__default["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", {
    id: "Time-Tracking"
  }, React__default["default"].createElement("g", {
    id: "Group"
  }, React__default["default"].createElement("g", {
    id: "Oval-4"
  }, React__default["default"].createElement("use", {
    fill: "#2196F3",
    fillRule: "evenodd",
    href: "#path-1"
  }), React__default["default"].createElement("circle", {
    stroke: "#E0E0E0",
    strokeWidth: "30",
    cx: "250",
    cy: "250",
    r: "235"
  })), React__default["default"].createElement("path", {
    d: "M265,484.528999 C387.797543,476.793763 485,374.748307 485,250 C485,198.485042 468.383166,149.568926 438.301946,109.375203 L265,256.929074 C265,377.756169 265,385.289682 265,484.528999 Z",
    id: "Oval-4-Copy-2",
    stroke: "#BDBDBD",
    strokeWidth: "30"
  }), React__default["default"].createElement("path", {
    d: "M250,470 C371.502645,470 470,371.502645 470,250 C470,195.109464 449.897594,144.914096 416.653218,106.374335 L250,250 L250,470 Z",
    id: "Oval-4-Copy",
    fill: "#2196F3"
  }), React__default["default"].createElement("path", {
    d: "M250,470 C371.502645,470 470,371.502645 470,250 C470,195.109464 449.897594,144.914096 416.653218,106.374335 L250,250 L250,470 Z",
    id: "Oval-4-Copy-3",
    fill: "url(#linearGradient-2)"
  }), React__default["default"].createElement("path", {
    d: "M109,162 L251.5,249.610392",
    id: "Line-Copy-2",
    stroke: "#E0E0E0",
    strokeWidth: "20",
    strokeLinecap: "square"
  }), React__default["default"].createElement("path", {
    d: "M432.070112,94 L249,251.212751",
    id: "Line-Copy",
    stroke: "#F5F5F5",
    strokeWidth: "20",
    strokeLinecap: "square"
  }), React__default["default"].createElement("path", {
    d: "M250,250 L250,500",
    id: "Line-2",
    stroke: "#F44336",
    strokeWidth: "4",
    strokeLinecap: "square"
  }), React__default["default"].createElement("circle", {
    id: "Oval-5",
    fill: "#FFFFFF",
    cx: "250.5",
    cy: "250.5",
    r: "21.5"
  })))));
};

var TimeTrackingAppIcon$1 = iconStyles()(TimeTrackingAppIcon);

module.exports = TimeTrackingAppIcon$1;
